var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7895 0H1.68421C0.757895 0 0 0.818182 0 1.81818V14.5455H1.68421V1.81818H11.7895V0ZM14.3158 3.63636H5.05263C4.12632 3.63636 3.36842 4.45455 3.36842 5.45455V18.1818C3.36842 19.1818 4.12632 20 5.05263 20H14.3158C15.2421 20 16 19.1818 16 18.1818V5.45455C16 4.45455 15.2421 3.63636 14.3158 3.63636ZM14.3158 18.1818H5.05263V5.45455H14.3158V18.1818Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftDuplicate);
export default __webpack_public_path__ + "static/media/shiftDuplicate.b90372bb6dba24fce63342c6ef4ca0ae.svg";
export { ForwardRef as ReactComponent };